var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8229 4.67805C12.1147 4.67805 13.1619 3.63083 13.1619 2.33902C13.1619 1.04722 12.1147 0 10.8229 0C9.53111 0 8.48389 1.04722 8.48389 2.33902C8.48389 3.63083 9.53111 4.67805 10.8229 4.67805Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6918 5.24023L11.725 5.24101C13.5155 5.293 14.9249 6.78665 14.8729 8.57721V9.07619C14.8729 9.32571 14.7794 9.60639 14.4987 9.60639H9.97318C9.57029 8.32463 8.39095 7.37851 6.97234 7.33732L6.97119 7.33729C7.42636 6.13266 8.57926 5.26592 9.94539 5.24023H11.6918Z",
    fill: "#8292E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6608 7.52571C5.95261 7.52571 6.99983 6.47849 6.99983 5.18668C6.99983 3.89487 5.95261 2.84766 4.6608 2.84766C3.369 2.84766 2.32178 3.89487 2.32178 5.18668C2.32178 6.47849 3.369 7.52571 4.6608 7.52571Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.56649 8.09062C5.55545 8.09032 5.5444 8.09002 5.53336 8.08984H3.78691C1.99593 8.12351 0.57141 9.60271 0.605077 11.3937C0.605256 11.4047 0.605554 11.4158 0.605853 11.4268V11.9258C0.605853 12.1753 0.699391 12.456 0.980069 12.456H8.3402C8.62088 12.456 8.71442 12.1753 8.71442 11.9258V11.4268C8.76641 9.63626 7.35705 8.14261 5.56649 8.09062Z",
    fill: "#8292E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.80893c95084ce3408a16b92c18f98e8e.svg";
export { ForwardRef as ReactComponent };